module.exports = __webpack_public_path__ + "img/CCC-HTFC-30.29e890e9.jpg";